module.exports = __webpack_public_path__ + "img/add@2x.8040cd12.png";